/**
 * Subscription Errors
 *
 * Typed subscription/payment errors used by chat API routes.
 *
 * Primary responsibilities:
 * - Carry HTTP status for subscription failures
 * - Carry optional limit reset metadata for client notices
 *
 * Dependencies:
 * - None
 */

export type SubscriptionRequiredErrorDetails = {
  reason?: string | null
  resetAt?: string | null
  resetWindow?: string | null
  limit?: number | null
  used?: number | null
  windowHours?: number | null
  creditsRequired?: number | null
  paymentPath?: string | null
}

export class SubscriptionRequiredError extends Error {
  status: number
  details?: SubscriptionRequiredErrorDetails

  constructor(message: string, details?: SubscriptionRequiredErrorDetails) {
    super(message)
    this.name = 'SubscriptionRequiredError'
    this.status = 402
    this.details = details
  }
}
